import { apiSlice } from "@app/api/apiSlice";

const addressSelectorApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAddress: builder.mutation({
      query: (addressUrl) => `static/public/nepal/${addressUrl}`,
    }),
  }),
  overrideExisting: true,
});

export const { useLoadAddressMutation } = addressSelectorApiSlice;
